<template>
  <div>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="m-3">
      <h3>Add New Notice</h3>
      <AddElement category_id="4"></AddElement>
    </div>
  </div>
</template>

<script>
import AddElement from "@/components/ElementComponents/AddElement.vue";

export default {

  name: "AddNewNotice",
  components: {
    AddElement,
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Notices',
          to: '/notices/all'
        }, {
          text: 'Add Notice',
          href: '#'
        }
      ],
    };
  },
};
</script>